import { langId } from "../languages"
const linkConfigPro = [
  {
    title: langId.HOME,
    baseSlug: "",
  },
  {
    title: langId.CEOS_VIEWS,
    baseSlug: "link-ceo-george-hongchoy-views-life-and-business",
  },
  {
    title: langId.CORPORATE_NEWS,
    baseSlug: "link-corporate-news-the-cabot-acquisition",
  },
  {
    title: langId.FEATURE_STORIES,
    baseSlug: "link-feature-stories",
    subMenu: [
      {
        title: langId.STORY1,
        baseSlug: "bespoke-internship",
        subMenu: true,
      },
      {
        title: langId.STORY2,
        baseSlug: "entrepreneurship",
        subMenu: true,
      },
      {
        title: langId.STORY3,
        baseSlug: "extraordinary-summer-internship",
        subMenu: true,
      },
    ],
  },
  // need to add three small pages
  {
    title: langId.LINK_TOGETHER_INITIATIVES,
    baseSlug: "link-together-initiatives-we-are-top-crew",
  },
  {
    title: langId.THE_LINK_MOMENTS,
    baseSlug: "link-marketing-updates-flourishing-night-time-economy",
  },
]

export default linkConfigPro
